import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    WidgetSilkBox,
    WidgetTrapBox,
} from 'src/domains/sportsbook/webview/components/raceBoxSelection/WidgetSilkAndTrap.style';

interface PropsType {
    selectionId: SelectionId;
}

export const RaceBoxSilkAndTrap = observer('RaceBoxSilkAndTrap', (props: PropsType) => {
    const { selectionId } = props;

    const selection = selectionId.getModel();
    const market = selection?.marketId === undefined ? null : selection.marketId2.getModel();

    if (selection === null) {
        return null;
    }

    if (market === null) {
        return null;
    }

    const eventModel = market.getEvent();
    if (eventModel === null) {
        return null;
    }

    if (market.isOutright === true) {
        return null;
    }

    const sport = eventModel.sport;

    if (sport === 'greyhoundracing') {
        return (
            <WidgetTrapBox
                trapNumber={selection.metaDataNumber}
                selectionId={selection.id2}
            />
        );
    }

    const silkUrl = selection.metaDataSilkUrl ?? '';
    const silkAltDesc = selection.metaDataSilk ?? '';

    return (
        <WidgetSilkBox
            alt={silkAltDesc}
            imgBase={{
                src: silkUrl,
                optimizeOptions: {
                    quality: 85,
                    width: 45,
                },
            }}
        />
    );
});
